import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import areaApi from 'api/areaApi';
import miscApi from 'api/miscApi';
import permissionApi from 'api/permissionApi';
import rideSupportChatApi from 'api/rideSupportChatApi';
import _ from 'lodash';

// MARK: --- Thunks ---
// lay danh sach cay khu vuc
export const thunkGetAreaTree = createAsyncThunk(
  'app/thunkGetAreaTree',
  async (params, thunkAPI) => {
    const res = await areaApi.getAreaList(params);
    return res;
  }
);

// lay app config
export const thunkGetAppConfig = createAsyncThunk(
  'app/thunkGetAppConfig',
  async (params, thunkAPI) => {
    const res = await miscApi.getConfig();
    return res;
  }
);

// lay ds banks
export const thunkGetBankList = createAsyncThunk(
  'app/thunkGetBankList',
  async (params, thunkAPI) => {
    const res = await miscApi.getBankList();
    return res;
  }
);

// lay ds quyen
export const thunkGetPermissionList = createAsyncThunk(
  'app/thunkGetPermissionList',
  async (params, thunkAPI) => {
    const res = await permissionApi.getPermissionList();
    return res;
  }
);

// tong so tin nhan ho tro xe ghep chua doc, dung cho badge tren sidebar
export const thunkGetRideSupportUnreadCount = createAsyncThunk(
  'app/thunkGetRideSupportUnreadCount',
  async (params, thunkAPI) => {
    const res = await rideSupportChatApi.getConversations({ page: 1, pageSize: 100 });
    return res;
  }
);

const initialState = {
  areaTree: {},
  appConfig: {},
  bankList: [],
  permissionList: [],
  rideSupportUnreadCount: 0,
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(thunkGetAreaTree.pending, (state, action) => {})
      .addCase(thunkGetAreaTree.rejected, (state, action) => {})
      .addCase(thunkGetAreaTree.fulfilled, (state, action) => {
        const { result, tree } = action.payload;
        if (result === 'success') {
          state.areaTree = tree ?? {};
        }
      })

      // app config
      .addCase(thunkGetAppConfig.pending, (state, action) => {})
      .addCase(thunkGetAppConfig.rejected, (state, action) => {})
      .addCase(thunkGetAppConfig.fulfilled, (state, action) => {
        const { result, config, operators, services } = action.payload;
        if (result === 'success') {
          state.appConfig['config'] = config;
          state.appConfig['operators'] = operators;
          state.appConfig['services'] = services;
        }
      })

      // bank list
      .addCase(thunkGetBankList.fulfilled, (state, action) => {
        const { code, data } = action.payload;
        if (data && _.isArray(data)) {
          state.bankList = data;
        }
      })

      // permission list
      .addCase(thunkGetPermissionList.pending, (state, action) => {})
      .addCase(thunkGetPermissionList.rejected, (state, action) => {})
      .addCase(thunkGetPermissionList.fulfilled, (state, action) => {
        const { result, permissionGroups } = action.payload;
        if (result === 'success') {
          state.permissionList = permissionGroups ?? [];
        }
      })

      // ride support chat unread count
      .addCase(thunkGetRideSupportUnreadCount.rejected, (state, action) => {})
      .addCase(thunkGetRideSupportUnreadCount.fulfilled, (state, action) => {
        const { items } = action.payload;
        if (_.isArray(items)) {
          state.rideSupportUnreadCount = items.reduce(
            (total, item) => total + (item?.unreadCount || 0),
            0
          );
        }
      });
  },
});

const { reducer, actions } = appSlice;
export const {} = actions;
export default reducer;
